import GoogleMapInitiator from './GoogleMapInitiator';
export default GoogleMapInitiator;
